/*
 *  Module for the Login page
 */
rs.module("content/user/account/login",
    [
        "layouts/pwa",
        "ui/framework/passkeys"
    ],

    function (pwa, passkeys) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, returnUrl) {

            // PWA install variables
            var isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent));
            var pwaInstallLink = $.js(jsSelectors.pwaInstallLink, { required: false, multiple: false });
            var pwaInstructionsLink = $.js(jsSelectors.pwaInstructionsLink, { required: false, multiple: false });
            var pwaInstructionsPrompt = $.js(jsSelectors.pwaInstructionsPrompt, { required: false, multiple: false });
            var pwaInstructionsPromptCloseButton = $.js(jsSelectors.pwaInstructionsPromptCloseButton, { required: false, multiple: true });

            // Event triggered by Windows desktop and Android devices, and only if the site is being viewed in a browser (NOT as a stand-alone PWA).
            // In this case, we show the PWA Install Link (hidden by default).
            // Note - this event will fire after $(document).ready
            let installPromptEvent;
            window.addEventListener("beforeinstallprompt", event => {

                // This event doesn't normally fire on iOS devices, except when you're emulating an iOS device on windows in browser F12 debug tools.
                // Therefore, do a safety check here so we don't ever show both versions of the pwaInstall/Instructions link.
                if (!isIOS) {

                    // Prevents the default mini-infobar or install dialog from appearing on mobile
                    event.preventDefault();

                    // Stash the event so it can be triggered later.
                    installPromptEvent = event;

                    // Show PWA Install Link (hidden by default)
                    pwaInstallLink.show();

                    console.log("[Login] beforeinstallprompt event was fired.");
                }
            });

            // Document Ready event handler
            $(document).ready(function () {

                // If running on iOS in a browser (NOT as a stand-alone PWA), show the PWA Instructions Link (hidden by default)
                if (isIOS && !pwa.isRunningStandAlonePWA()) {
                    pwaInstructionsLink.show();
                }
            });

            // Event triggered by Windows desktop and Android devices only, when the PWA Install Link is clicked
            pwaInstallLink.click(function (event) {

                console.log("[Login] PWA Install Link Clicked");
                event.preventDefault();

                // Show the prompt to auto install the PWA (i.e., Add to Home Screen)
                installPromptEvent.prompt();

                // Wait for the user to respond to the prompt
                installPromptEvent.userChoice.then(choice => {

                    if (choice.outcome === "accepted") {
                        console.log("[Login] User accepted the Add To Home Screen install prompt");

                        // Hide the PWA Install Link
                        pwaInstallLink.hide();

                    } else {
                        console.log("[Login] User dismissed the Add To Home Screen install prompt");
                    }
                    // Clear the saved prompt since it can't be used again
                    installPromptEvent = null;
                });
            });

            // Event triggered when the PWA Instructions Link is clicked (the link will only be visibile on iOS devices)
            // which opens a modal prompt containing the instructions
            pwaInstructionsLink.click(function (event) {

                console.log("[Login] PWA Instructions Link Clicked");
                event.preventDefault();

                // Show the prompt with instructions on how to manually install the PWA (i.e., Add to Home Screen)
                pwaInstructionsPrompt.modal('show');
            });

            // Handle the closing of the PWA Instructions Link modal prompt
            pwaInstructionsPromptCloseButton.click(function () {

                pwaInstructionsPrompt.modal('hide');
                return false;
            });

            var loginErrorDiv = $.js(jsSelectors.jsLoginErrors);
            var loginDialog = $.js(jsSelectors.loginDialog);

            // Initialize passkey registration flow
            passkeys.initializeLogin({
                loginButton: jsSelectors.passkeyLoginButton,
            },
                backendUrls,
                returnUrl,
                onLoginError,
                onPasswordlessStart,
                onPasswordlessComplete
            );

            // Callback for when a passwordless authentication ceremony begins
            function onPasswordlessStart() {
                // disable login controls
                loginDialog.find(":input").setDisabled();
                loginDialog.find(":button").setDisabled();
            }

            // Callback for when a passwordless authentication ceremony ends
            function onPasswordlessComplete() {
                // enable login controls
                loginDialog.find(":input").setDisabled(false);
                loginDialog.find(":button").setDisabled(false);
            }

            // Handles login failures
            function onLoginError(error) {
                // clear any existing model errors which may exist
                $(".validation-summary-errors").html("");

                if (error){
                    // add errors to our validation summary 
                    loginErrorDiv.html("<ul><li>" + error + "</li></ul>");

                    // show the validation summary
                    loginErrorDiv.show();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);